import { useState, useEffect } from 'react'
import { motion } from 'framer-motion'
import styles from './Hero.module.css'

const codeLines = [
  { text: 'from', type: 'keyword' },
  { text: ' luminox ', type: 'normal' },
  { text: 'import', type: 'keyword' },
  { text: ' LuminoxClient', type: 'normal' },
  { text: '\n\n', type: 'normal' },
  { text: 'client = LuminoxClient(\n', type: 'normal' },
  { text: '    base_url=', type: 'normal' },
  { text: '"http://localhost:8029/api/v1"', type: 'string' },
  { text: '\n)\n\n', type: 'normal' },
  { text: '# Create a session', type: 'comment' },
  { text: '\nsession = client.sessions.create()\n\n', type: 'normal' },
  { text: '# Store messages', type: 'comment' },
  { text: '\nclient.sessions.store_message(\n', type: 'normal' },
  { text: '    session_id=session.id,\n', type: 'normal' },
  { text: '    blob={', type: 'normal' },
  { text: '"role"', type: 'string' },
  { text: ': ', type: 'normal' },
  { text: '"user"', type: 'string' },
  { text: ', ', type: 'normal' },
  { text: '"content"', type: 'string' },
  { text: ': ', type: 'normal' },
  { text: '"Hello!"', type: 'string' },
  { text: '},\n', type: 'normal' },
  { text: '    format=', type: 'normal' },
  { text: '"openai"', type: 'string' },
  { text: '\n)\n\n', type: 'normal' },
  { text: '# Enable self-learning', type: 'comment' },
  { text: '\nspace = client.spaces.create()\n', type: 'normal' },
  { text: 'session = client.sessions.create(space_id=space.id)', type: 'normal' },
]

export default function CodeWindow() {
  const [displayedCode, setDisplayedCode] = useState<Array<{ text: string; type: string }>>([])
  const [currentIndex, setCurrentIndex] = useState(0)
  const [currentCharIndex, setCurrentCharIndex] = useState(0)

  useEffect(() => {
    if (currentIndex >= codeLines.length) return

    const currentLine = codeLines[currentIndex]
    const typingSpeed = currentLine.type === 'comment' ? 30 : 20

    if (currentCharIndex < currentLine.text.length) {
      const timeout = setTimeout(() => {
        setDisplayedCode(prev => {
          const newCode = [...prev]
          if (newCode.length === currentIndex) {
            newCode.push({ text: '', type: currentLine.type })
          }
          newCode[currentIndex] = {
            text: currentLine.text.slice(0, currentCharIndex + 1),
            type: currentLine.type
          }
          return newCode
        })
        setCurrentCharIndex(prev => prev + 1)
      }, typingSpeed)
      return () => clearTimeout(timeout)
    } else {
      setCurrentIndex(prev => prev + 1)
      setCurrentCharIndex(0)
    }
  }, [currentIndex, currentCharIndex])

  return (
    <motion.div
      className={styles.codeWindow}
      whileHover={{ boxShadow: '0 30px 80px rgba(0, 0, 0, 0.6), 0 0 60px rgba(255, 215, 0, 0.1)' }}
    >
      <div className={styles.codeHeader}>
        <div className={styles.codeDots}>
          <span style={{ background: '#ff5f57' }}></span>
          <span style={{ background: '#febc2e' }}></span>
          <span style={{ background: '#28c840' }}></span>
        </div>
        <span className={styles.codeTitle}>quickstart.py</span>
      </div>
      <pre className={styles.codeContent}>
        <code>
          {displayedCode.map((segment, index) => (
            <span key={index} className={styles[segment.type]}>
              {segment.text}
            </span>
          ))}
          <motion.span
            className={styles.cursor}
            animate={{ opacity: [1, 0] }}
            transition={{ duration: 0.5, repeat: Infinity }}
          >
            |
          </motion.span>
        </code>
      </pre>
    </motion.div>
  )
}
